import { formatDate } from '@angular/common';
import { Component, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConvenioService } from 'src/app/services/convenio/convenio.service';
import { DepositosService } from 'src/app/services/convenio/depositos.service';
import { TransportistaService } from 'src/app/services/convenio/transportista.service';
import { AppState } from 'src/app/state/app.state';
import { selectUser } from 'src/app/state/selectors/user.selectors';
import { EventEmitter } from 'stream';

@Component({
  selector: 'app-convenio',
  templateUrl: './convenio.component.html',
  styleUrls: ['./convenio.component.scss']
})
export class ConvenioComponent implements OnInit {
  dataConvenio: any
  dataTransportistas: any
  user: any;
  formSaveConvenio: FormGroup;
  formUpdateConvenio: FormGroup;
  updateConvenioModal: boolean = false;
  formSaveTransportista: FormGroup;
  saveTransportistaModal: boolean = false;
  formSaveDeposito: FormGroup;
  updateDepositoModal: boolean = false;
  public temp: any
  public rowsT: any
  constructor(
    private transportistaService: TransportistaService,
    private depositoService: DepositosService,
    private conveniService: ConvenioService,
    private router: Router,
    private store: Store<AppState>,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private ngxUiLoaderService: NgxUiLoaderService,
  ) { }

  ngOnInit(): void {
    this.store.select(selectUser).subscribe(user => this.user = user);
    this.getData();
    this.createForms()

  }

  getData() {
    this.ngxUiLoaderService.start()

    this.conveniService.getConvenios().
      subscribe(data => {
        this.dataConvenio = data;
        this.temp = [...this.dataConvenio];
        this.rowsT = [...this.dataConvenio];

        this.dataConvenio = data;
        console.log(this.dataConvenio);

      })
    this.transportistaService.getTransportistas().
      subscribe(data => {
        this.dataTransportistas = data;
        console.log(this.dataTransportistas);

      })
    this.ngxUiLoaderService.stop()
  }

  createForms() {
    this.formSaveConvenio = this.formBuilder.group({
      id_scct_transportista: ['', Validators.required],
      fecha_inicio: ['', Validators.required],
      fecha_cierre: ['', Validators.required]

    });

    this.formSaveTransportista = this.formBuilder.group({
      transportista: ['', Validators.required],
      correo: ['', Validators.required],
      rfc: [,],
      razon_social: [,],
      domicilio: [,],
      codigo_postal: [,]

    });

    this.formSaveDeposito = this.formBuilder.group({
      monto: ['', Validators.required],
      fecha_deposito: ['', Validators.required],
      clave_rastreo: ['', Validators.required],
      id_scct_convenio: [, Validators.required]

    });

    this.formUpdateConvenio = this.formBuilder.group({
      id_scct_convenio: ['', Validators.required],
      ufecha_inicio: [, Validators.required],
      ufecha_cierre: [, Validators.required],
      uestatus: ['', Validators.required],
    });

  }


  saveConvenio() {

    if (!this.formSaveConvenio.valid) {
      return this.toastr.error(`Seleccione todos los campos`, '', { positionClass: 'toast-bottom-right' });
    }
    this.ngxUiLoaderService.start();
    this.conveniService.saveConvenio(this.formSaveConvenio.value).
      subscribe(data => {
        this.ngxUiLoaderService.stop();
        this.getData();
        this.finished('Convenio')

      })
  }


  finished(type: string) {
    this.saveTransportistaModal = false;
    this.toastr.success(`${type} guardado con éxito`, '', { positionClass: 'toast-bottom-right' });
    this.resetForm();
    this.router.navigate(['/dashboard/dashboard-cobro']);
  }

  resetForm() {
    this.formSaveConvenio.reset();
    this.formSaveTransportista.reset();
    this.formUpdateConvenio.reset();
    this.formSaveDeposito.reset();
  }

  saveTransportista() {

    if (!this.formSaveTransportista.valid) {
      return this.toastr.error(`Seleccione todos los campos`, '', { positionClass: 'toast-bottom-right' });
    }
    this.ngxUiLoaderService.start();
    try {
      this.transportistaService.saveTransportista(this.formSaveTransportista.value).
        subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.getData();
          this.finished('Transportista')
        })
    } catch (error) {
      this.toastr.success(`Se ha producido un error`, '', { positionClass: 'toast-bottom-right' });
    }


  }
  saveDeposito() {

      if (!this.formSaveDeposito.valid) {
        return this.toastr.error(`Seleccione todos los campos`, '', { positionClass: 'toast-bottom-right' });
      }
      try {
      this.ngxUiLoaderService.start();
      this.depositoService.saveDeposito(this.formSaveDeposito.value).
        subscribe(data => {
          console.log(this.formSaveDeposito.value);
          this.updateDepositoModal = false;
          this.ngxUiLoaderService.stop();
          this.getData();
          this.finished('Deposito')
        })
    } catch (error) {
      this.ngxUiLoaderService.stop();
      this.toastr.success(`Se ha producido un error`, '', { positionClass: 'toast-bottom-right' });
    }
  }
  openConvenioModal(convenio) {
    this.updateConvenioModal = true
    console.log(convenio);
    this.formUpdateConvenio.controls['id_scct_convenio'].setValue(convenio.id)
    this.formUpdateConvenio.controls['uestatus'].setValue(convenio.estatus)
    this.formUpdateConvenio.controls['ufecha_inicio'].setValue(formatDate(convenio.fecha_inicio, 'yyyy-MM-dd', 'en'))
    this.formUpdateConvenio.controls['ufecha_cierre'].setValue(formatDate(convenio.fecha_cierre, 'yyyy-MM-dd', 'en'))


  }
  updateConvenio() {
    try {
      if (!this.formUpdateConvenio.valid) {
        return this.toastr.error(`Seleccione todos los campos`, '', { positionClass: 'toast-bottom-right' });
      }
      this.ngxUiLoaderService.start();
      this.conveniService.updateConvenio(this.formUpdateConvenio.value).
        subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.getData();
          this.finished('Convenio')
          this.updateConvenioModal = false;

        })
    } catch (error) {
      this.toastr.success(`Se ha producido un error`, '', { positionClass: 'toast-bottom-right' });
    }

  }

}
